/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-north-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://iqaym8s295.execute-api.eu-north-1.amazonaws.com/test",
            "region": "eu-north-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://gbyrfovbxjgvrkorayjjssyazu.appsync-api.eu-north-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-north-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-north-1:f4ee2985-9873-417f-877a-f97601f89877",
    "aws_cognito_region": "eu-north-1",
    "aws_user_pools_id": "eu-north-1_hwVQcJv0W",
    "aws_user_pools_web_client_id": "4f2qc0ms3l7fr3imprqu8jjfke",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "FAMILY_NAME",
        "GIVEN_NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "likabehandlignsplan-hosting-test",
    "aws_content_delivery_bucket_region": "eu-north-1",
    "aws_content_delivery_url": "https://d1ldqhajx9cxrd.cloudfront.net",
    "aws_user_files_s3_bucket": "likabehandlingsplan39effe698d494957a569d444d56b211155-test",
    "aws_user_files_s3_bucket_region": "eu-north-1"
};


export default awsmobile;
